import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('log/error/api'))
  },

}



// WEBPACK FOOTER //
// ./src/api/LogErrorApiService.js